import { Storage } from ".";
import { WritableDraft } from "immer/dist/internal";

export const empty = (state: WritableDraft<Storage>[]) => {
  localStorage.setItem("current", "[]");

  state.splice(0, state.length);
};
